<template>
  <div class="designerpage">

    <primepanels-designer-question-door-range
      :fabricator="fabricator"
      v-model:target="door.attr.door_range"
      :ranges="ranges"
      :defaults="defaults()"
      :reference_on="reference_on"
    ></primepanels-designer-question-door-range>

    <div>

      <designer-question-steel-inserts
        :fabricator="fabricator"
        :slab="door.attr.slab"
        v-model:target="door.attr.steel_inserts"
      ></designer-question-steel-inserts>

      <div class="designeroption">
        <h3>
          Panel Options
        </h3>
        <designer-question-panel-category
          :fabricator="fabricator"
          :secured-by-design="door.attr.secured_by_design"
          :door-range="door.attr.door_range"
          v-model:target="door.attr.panel_category"
        ></designer-question-panel-category>
        <designer-question-panel-core
          :fabricator="fabricator"
          :panel-category="door.attr.panel_category"
          v-model:target="door.attr.panel_core"
        ></designer-question-panel-core>
        <designer-question-panel-depth
          :fabricator="fabricator"
          :panel-category="door.attr.panel_category"
          v-model:target="door.attr.panel_depth"
        ></designer-question-panel-depth>
        <designer-question-panel-depth-bespoke
          :fabricator="fabricator"
          :panel-depth="door.attr.panel_depth"
          v-model:target="door.attr.panel_depth_bespoke"
        ></designer-question-panel-depth-bespoke>
      </div>

      <designer-question-select-panel
        :fabricator="fabricator"
        :secured-by-design="door.attr.secured_by_design"
        :door-range="door.attr.door_range"
        :panel-category="door.attr.panel_category"
        v-model:target="door.attr.slab"
      ></designer-question-select-panel>

      <designer-question-slab-cassettes
        v-model:target="door.attr.slab_cassette"
        :slab="door.attr.slab"
        :type-range="door.attr.door_range"
        :fabricator="fabricator"
      ></designer-question-slab-cassettes>

      <designer-question-panel-trim
        :fabricator="fabricator"
        :slab="door.attr.slab"
        v-model:target="door.attr.panel_trim"
      ></designer-question-panel-trim>

      <designer-question-frame-material :slab="door.attr.slab"
                                           :fabricator="fabricator"
                                           v-model:target="door.attr.frame_material"></designer-question-frame-material>
    </div>

    <hallmark-designer-question-select-frame-style v-show="false" :fabricator="fabricator"
                                                   :is-firedoor="is_firedoorrange"
                                                   :frame-material="door.attr.frame_material"
                                                   v-model:target="door.attr.frame_style"
    ></hallmark-designer-question-select-frame-style>

    <div class="designeroption" v-show="false">
      <designer-question-opening-direction v-show="technical_should_show" :fabricator="fabricator"
                                           v-model:target="door.attr.opening_direction"
                                           :frame-combination="door.attr.frame_style.frame_id"
                                           :type-range="door.attr.door_range"
      ></designer-question-opening-direction>
    </div>

    <hallmark-designer-question-colour-range
      title="Colour Ranges"
      :fabricator="fabricator"
      :collection="door.attr.collection"
      :type-range="door.attr.door_range"
      :panel-category="door.attr.panel_category"
      v-model:target="door.attr.colour_range"
    ></hallmark-designer-question-colour-range>

    <div class="designeroption" data-designer-component-id="door_colour">
      <h3>Choose Your Panel Colour
      </h3>
      <div class="colourtabs">
        <ul>
          <li><a href="#dc-tabs-1">External Colour</a></li>
          <li><a href="#dc-tabs-2">Internal Colour</a></li>
        </ul>
        <div id="dc-tabs-1">
          <wb-designer-question-door-colour-external :fabricator="fabricator" :slab="door.attr.slab"
                                                     :door-range="door.attr.door_range"
                                                     :colour-range="door.attr.colour_range"
                                                     :slab-cassette="door.attr.slab_cassette"
                                                     v-model:target="door.attr.external_colour"></wb-designer-question-door-colour-external>

          <designer-question-ral-colour :fabricator="fabricator" :colour-id="door.attr.external_colour"
                                        title="External Door Colour"
                                        :label="door.attr.external_colour === 1082 ? 'Enter your system supplier here' : 'Please enter the RAL/BS colour number you require for your External Door Colour: - extends lead time 10 days'"
                                        v-model:target="door.attr.external_colour_ral"></designer-question-ral-colour>
        </div>
        <div id="dc-tabs-2">
          <hallmark-designer-question-door-colour-internal :fabricator="fabricator" :slab="door.attr.slab"
                                                           :external-colour="door.attr.external_colour"
                                                           :door-range="door.attr.door_range"
                                                           :colour-range="door.attr.colour_range"
                                                           :slab-cassette="door.attr.slab_cassette"
                                                           v-model:target="door.attr.door_colour_internal"></hallmark-designer-question-door-colour-internal>

          <designer-question-ral-colour :fabricator="fabricator" :colour-id="door.attr.door_colour_internal"
                                        title="Internal Door Colour"
                                        :label="door.attr.door_colour_internal === 1082 ? 'Enter your system supplier here' : 'Please enter the RAL/BS colour number you require for your Internal Door Colour: - extends lead time 10 days'"
                                        v-model:target="door.attr.door_colour_internal_ral"></designer-question-ral-colour>
        </div>
      </div>
    </div>

    <div class="designeroption" data-designer-component-id="frame_colour" v-show="false">
      <h3>Pick Your Frame Colour</h3>

      <div class="colourtabs">
        <ul>
          <li><a href="#tabs-1">External Colour</a></li>
          <li><a href="#tabs-2">Internal Colour</a></li>
        </ul>
        <div id="tabs-1">
          <wb-designer-question-frame-colour-external :fabricator="fabricator"
                                                      :frame-material="door.attr.frame_material"
                                                      :slab="door.attr.slab"
                                                      :profile="door.attr.profile"
                                                      :door-range="door.attr.door_range"
                                                      :slab-cassette="door.attr.slab_cassette"
                                                      :colour-range="door.attr.colour_range"
                                                      v-model:target="door.attr.frame_colour_external"></wb-designer-question-frame-colour-external>

          <designer-question-ral-colour :fabricator="fabricator" :colour-id="door.attr.frame_colour_external"
                                        title="External Frame Colour"
                                        :label="'Enter your system supplier here'"
                                        v-model:target="door.attr.frame_colour_external_ral"></designer-question-ral-colour>
        </div>
        <div id="tabs-2">
          <wb-designer-question-frame-colour-internal :fabricator="fabricator"
                                                      :frame-material="door.attr.frame_material"
                                                      :frame-colour-external="door.attr.frame_colour_external"
                                                      :slab="door.attr.slab"
                                                      :profile="door.attr.profile"
                                                      :door-range="door.attr.door_range"
                                                      :slab-cassette="door.attr.slab_cassette"
                                                      :colour-range="door.attr.colour_range"
                                                      v-model:target="door.attr.frame_colour_internal"></wb-designer-question-frame-colour-internal>

          <designer-question-ral-colour :fabricator="fabricator" :colour-id="door.attr.frame_colour_internal"
                                        title="Internal Frame Colour"
                                        :label="'Enter your system supplier here'"
                                        v-model:target="door.attr.frame_colour_internal_ral"></designer-question-ral-colour>
        </div>
      </div>
    </div>

    <div>
      <hallmark-designer-question-secured-by-design
        v-show="false"
        :fabricator="fabricator"
        v-model:target="door.attr.secured_by_design"
        :title="'Do you require enhanced security?'"
      ></hallmark-designer-question-secured-by-design>

      <designer-question-door-glass-laminated :fabricator="fabricator"
                                              title="Laminated Glass:"
                                              :slab="door.attr.slab"
                                              :frame-style="door.attr.frame_style"
                                              :side-panels="door.attr.side_panels"
                                              :secured-by-design="door.attr.secured_by_design"
                                              :is-firedoor="is_firedoorrange"
                                              :collection="door.attr.collection"
                                              :door_range="door.attr.door_range"
                                              v-model:target="door.attr.laminated_glass"
                                              v-show="false"
      ></designer-question-door-glass-laminated>

    </div>

    <div>
      <wb-designer-question-glass-design :fabricator="fabricator"
                                         v-model:target="door.attr.glass_design"
                                         :laminated-glass="door.attr.laminated_glass"
                                         :door-range="door.attr.door_range"
                                         :slab="door.attr.slab"></wb-designer-question-glass-design>
    </div>

    <wb-designer-question-glass-backing-design :fabricator="fabricator"
                                               v-model:target="door.attr.glass_backing_design"
                                               :slab="door.attr.slab"
                                               :door-range="door.attr.door_range"
                                               :glass-design="door.attr.glass_design"></wb-designer-question-glass-backing-design>

    <hallmark-designer-question-select-frame-sidepanels :fabricator="fabricator"
                                                        v-model:target="door.attr.side_panels"
                                                        :door-range="door.attr.door_range"
                                                        :frame-style="door.attr.frame_style"
                                                        :frame-profile="door.attr.profile"
                                                        :frame-material="door.attr.frame_material"
                                                        :laminated-glass="door.attr.laminated_glass"
                                                        :frame-colour-internal="door.attr.frame_colour_internal"
                                                        :frame-colour-external="door.attr.frame_colour_external"
                                                        :secured-by-design="door.attr.secured_by_design"
                                                        :slab="door.attr.slab"
                                                        :measurements.sync="door.attr.measurements"
    ></hallmark-designer-question-select-frame-sidepanels>



    <div>
      <hallmark-designer-question-hardware-suite-selector v-if="!is_firedoorrange"
                                                          :fabricator="fabricator"
                                                          v-model:target="door.attr.hardware_suite"
                                                          :door-range="door.attr.door_range"
                                                          :slab="door.attr.slab"
                                                          :secured-by-design="door.attr.secured_by_design"
                                                          :opening-direction="door.attr.opening_direction"
                                                          :profile="door.attr.profile"
                                                          :collection="door.attr.collection"
                                                          :suites="suites"></hallmark-designer-question-hardware-suite-selector>
    </div>
    <div>

      <wb-designer-question-hardware-colour-with-suite
                                                       v-show="door.attr.door_range !== 175"
                                                       :fabricator="fabricator"
                                                       v-model:target="door.attr.hardware_colour"
                                                       :sbd="door.attr.secured_by_design"
                                                       :slab="door.attr.slab"
                                                       :hardware-suite="door.attr.hardware_suite"
                                                       :door-range="door.attr.door_range"
                                                       :profile="door.attr.profile"
                                                       :opening-direction="door.attr.opening_direction">
      </wb-designer-question-hardware-colour-with-suite>
    </div>
    <div v-show="false">
      <wb-designer-question-hardware-handle-with-suite :fabricator="fabricator"
                                                       v-model:target="door.attr.hardware_handle"
                                                       :slab="door.attr.slab"
                                                       :secured-by-design="door.attr.secured_by_design"
                                                       :opening-direction="door.attr.opening_direction"
                                                       :hardware-colour="door.attr.hardware_colour"
                                                       :hardware-suite="door.attr.hardware_suite"
                                                       :door-range="door.attr.door_range"
                                                       :profile="door.attr.profile"
                                                       :extra_text="door.attr.hardware_handle === 361 || door.attr.hardware_handle === 1391 ? 'Please note this handle is NOT powder coated' : ''"
      ></wb-designer-question-hardware-handle-with-suite>

      <designer-question-hardware-handle-split-spindle v-show="technical_should_show" :fabricator="fabricator"
                                                       v-model:target="door.attr.hardware_handle_split_spindle"
                                                       :hardware-handle="door.attr.hardware_handle"
                                                       :opening-direction="door.attr.opening_direction"
                                                       :slab="door.attr.slab"></designer-question-hardware-handle-split-spindle>

      <designer-question-hardware-handle-internal :fabricator="fabricator"
                                                  v-model:target="door.attr.hardware_handle_internal"
                                                  :slab="door.attr.slab"
                                                  :secured-by-design="door.attr.secured_by_design"
                                                  :opening-direction="door.attr.opening_direction"
                                                  :hardware-colour="door.attr.hardware_colour"
                                                  :door-range="door.attr.door_range"
                                                  :profile="door.attr.profile"
                                                  :handle-external="door.attr.hardware_handle"></designer-question-hardware-handle-internal>

      <div v-if="!is_firedoorrange">
        <designer-question-hardware-decorative-handle :fabricator="fabricator"
                                                      v-model:target="door.attr.hardware_decorative_handle"
                                                      :slab="door.attr.slab"
                                                      :hardware-colour="door.attr.hardware_colour"
                                                      :door-range="door.attr.door_range"></designer-question-hardware-decorative-handle>

        <designer-question-hardware-decorative-handle-position :fabricator="fabricator"
                                                               v-model:target="door.attr.hardware_decorative_handle_pos"
                                                               :slab="door.attr.slab"
                                                               :frame-material="door.attr.frame_material"
                                                               :hardware-decorative-handle="door.attr.hardware_decorative_handle"></designer-question-hardware-decorative-handle-position>
      </div>
    </div>
    <div>
      <wb-designer-question-hardware-escutcheon :fabricator="fabricator"
                                                v-model:target="door.attr.hardware_escutcheon"
                                                :slab="door.attr.slab"
                                                :secured-by-design="door.attr.secured_by_design"
                                                :hardware-colour="door.attr.hardware_colour"
                                                :hardware-handle="door.attr.hardware_handle"
                                                :door-range="door.attr.door_range"
                                                :profile="door.attr.profile"></wb-designer-question-hardware-escutcheon>

      <designer-question-hardware-escutcheon-position :fabricator="fabricator"
                                                      v-model:target="door.attr.hardware_escutcheon_pos"
                                                      :slab="door.attr.slab"
                                                      :frame-material="door.attr.frame_material"
                                                      :hardware-escutcheon="door.attr.hardware_escutcheon"></designer-question-hardware-escutcheon-position>
    </div>

    <div v-if="is_stable">
      <wb-designer-question-hardware-escutcheon-stable :fabricator="fabricator"
                                                       title="Stable Bottom Leaf Escutcheon"
                                                       v-model:target="door.attr.hardware_escutcheon_stable"
                                                       :slab="door.attr.slab"
                                                       :secured-by-design="door.attr.secured_by_design"
                                                       :hardware-colour="door.attr.hardware_colour"
                                                       :hardware-handle="door.attr.hardware_handle"
                                                       :hardware-escutcheon="door.attr.hardware_escutcheon"
                                                       :door-range="door.attr.door_range"></wb-designer-question-hardware-escutcheon-stable>

      <wb-designer-question-hardware-escutcheon-stable-position :fabricator="fabricator"
                                                                v-model:target="door.attr.hardware_escutcheon_stable_pos"
                                                                :slab="door.attr.slab"
                                                                :frame-material="door.attr.frame_material"
                                                                :hardware-escutcheon="door.attr.hardware_escutcheon_stable"
                                                                :door-range="door.attr.door_range"></wb-designer-question-hardware-escutcheon-stable-position>
    </div>

    <div>
      <wb-designer-question-hardware-letterbox :fabricator="fabricator"
                                               v-model:target="door.attr.hardware_letterbox"
                                               :secured-by-design="door.attr.secured_by_design"
                                               :slab="door.attr.slab"
                                               :side-panels="door.attr.side_panels"
                                               :frame-id="door.attr.frame_style.frame_id"
                                               :hardware-handle="door.attr.hardware_handle"
                                               :hardware-colour="door.attr.hardware_colour"
                                               :door-range="door.attr.door_range"></wb-designer-question-hardware-letterbox>

      <designer-question-hardware-letterbox-cowl :fabricator="fabricator"
                                                 v-model:target="door.attr.hardware_letterbox_cowl"
                                                 :secured-by-design="door.attr.secured_by_design"
                                                 :hardware-letterplate="door.attr.hardware_letterbox"
                                                 :hardware-colour="door.attr.hardware_colour"></designer-question-hardware-letterbox-cowl>

      <designer-question-hardware-letterbox-position :fabricator="fabricator"
                                                     v-model:target="door.attr.hardware_letterbox_pos"
                                                     :slab="door.attr.slab"
                                                     :side-panels="door.attr.side_panels"
                                                     :frame-id="door.attr.frame_style.frame_id"
                                                     :frame-material="door.attr.frame_material"
                                                     :hardware-letterbox="door.attr.hardware_letterbox"></designer-question-hardware-letterbox-position>
    </div>
    <div>
      <wb-designer-question-hardware-knocker :fabricator="fabricator"
                                             v-model:target="door.attr.hardware_knocker"
                                             :slab="door.attr.slab"
                                             :hardware-handle="door.attr.hardware_handle"
                                             :hardware-spyhole="door.attr.hardware_spy_hole"
                                             :hardware-colour="door.attr.hardware_colour"
                                             :door-range="door.attr.door_range"
                                             title="Pick A Knocker (supplied loose)"
      ></wb-designer-question-hardware-knocker>

      <designer-question-hardware-knocker-position :fabricator="fabricator"
                                                   v-model:target="door.attr.hardware_knocker_pos"
                                                   :slab="door.attr.slab"
                                                   :frame-material="door.attr.frame_material"
                                                   :hardware-knocker="door.attr.hardware_knocker"></designer-question-hardware-knocker-position>
    </div>
    <div>
      <wb-designer-question-hardware-spy-hole :fabricator="fabricator"
                                              v-model:target="door.attr.hardware_spy_hole"
                                              :slab="door.attr.slab"
                                              :secured-by-design="door.attr.secured_by_design"
                                              :glass-design="door.attr.glass_design"
                                              :hardware-handle="door.attr.hardware_handle"
                                              :hardware-knocker="door.attr.hardware_knocker"
                                              :hardware-colour="door.attr.hardware_colour"
                                              :door-range="door.attr.door_range"
                                              title="Choose A Spy Hole (supplied loose)"
      ></wb-designer-question-hardware-spy-hole>

      <designer-question-hardware-spy-hole-position :fabricator="fabricator"
                                                    v-model:target="door.attr.hardware_spy_hole_pos"
                                                    :slab="door.attr.slab"
                                                    :frame-material="door.attr.frame_material"
                                                    :hardware-spy-hole="door.attr.hardware_spy_hole"></designer-question-hardware-spy-hole-position>
    </div>
    <div class="designeroption" v-show="[166,167,168,169].includes(door.attr.door_range)" data-designer-component-id="numerals">
      <designer-question-hardware-numerals :fabricator="fabricator"
                                           v-model:target="door.attr.numerals"
                                           :slab="door.attr.slab"
                                           :hardware-handle="door.attr.hardware_handle"
                                           :hardware-colour="door.attr.hardware_colour"
                                           title="Numerals (supplied loose)"></designer-question-hardware-numerals>
    </div>

    <div v-show="false">
      <wb-designer-question-hardware-hinge :fabricator="fabricator"
                                           v-model:target="door.attr.hardware_hinge"
                                           :slab="door.attr.slab"
                                           :opening_direction="door.attr.opening_direction"
                                           :secured-by-design="door.attr.secured_by_design"
                                           :hardware-colour="door.attr.hardware_colour"
                                           :hinge-side="door.attr.hinge_side"
                                           :frame-material="door.attr.frame_material"
                                           :door-range="door.attr.door_range"
                                           :hinge-qty="door.attr.hinge_qty"
      ></wb-designer-question-hardware-hinge>

      <div class="designeroption">
        <hallmark-designer-question-hardware-hinge-bolts v-if="!is_firedoorrange"
                                                         :fabricator="fabricator"
                                                         v-model:target="door.attr.hardware_hinge_bolts"
                                                         :hardware-hinge="door.attr.hardware_hinge"
                                                         :secured-by-design="door.attr.secured_by_design"
                                                         :hardware-colour="door.attr.hardware_colour"></hallmark-designer-question-hardware-hinge-bolts>
      </div>

    </div>

    <div v-show="false">
      <designer-question-technical-profile :fabricator="fabricator"
                                           :frame-colour-internal="door.attr.frame_colour_internal"
                                           :frame-colour-external="door.attr.frame_colour_external"
                                           :frame-material="door.attr.frame_material"
                                           :secured-by-design="door.attr.secured_by_design"
                                           :hardware-handle="door.attr.hardware_handle"
                                           :hardware-escutcheon="door.attr.hardware_escutcheon"
                                           :opening-direction="door.attr.opening_direction"
                                           v-model:target="door.attr.profile"
                                           :maintitle="'Select your frame profile & size'"
                                           :title="''"
                                           :door-range="door.attr.door_range"
      ></designer-question-technical-profile>
    </div>

    <div v-show="false">
      <wb-designer-question-door-drip-colour v-show="technical_should_show" :fabricator="fabricator"
                                             title="Choose A Door Drip colour"
                                             :external-colour="door.attr.external_colour"
                                             v-model:target="door.attr.door_drip_colour"
                                             :frame-profile="door.attr.profile"
                                             :door-range="door.attr.door_range"></wb-designer-question-door-drip-colour>
    </div>

    <hallmark-designer-question-cut-to-size
      :fabricator="fabricator"
      :panel-category="door.attr.panel_category"
      v-model:target="door.attr.cut_to_size"
    ></hallmark-designer-question-cut-to-size>

    <div v-show="door.attr.cut_to_size == 83">
      <hallmark-designer-question-measurements title="Enter Your Required Measurements"
                                               :fabricator="fabricator"
                                               :slab="door.attr.slab"
                                               :external-colour="door.attr.external_colour"
                                               :internal-colour="door.attr.door_colour_internal"
                                               :frame-profile="door.attr.profile"
                                               :threshold="door.attr.threshold"
                                               :frame-id="door.attr.frame_style.frame_id"
                                               :side-panels="door.attr.side_panels"
                                               :addons="door.attr.addons"
                                               :cill="door.attr.cill"
                                               :hardware-lock="door.attr.hardware_lock"
                                               :hardware-hinge="door.attr.hardware_hinge"
                                               :hardware-handle="door.attr.hardware_handle"
                                               :hardware-knocker="door.attr.hardware_knocker"
                                               :hardware-spy-hole="door.attr.hardware_spy_hole"
                                               :hardware-escutcheon="door.attr.hardware_escutcheon"
                                               :hardware-letterbox="door.attr.hardware_letterbox"
                                               :hardware-letterbox-position="door.attr.hardware_letterbox_pos"
                                               v-model:target="door.attr.measurements"
                                               :extra_text="measurements_extra_text"
                                               :cut-to-size="door.attr.cut_to_size == 83"
                                               :panel-designer="true"
                                               :mdd="mdd"
                                               :technical_should_show="technical_should_show"
                                               :show-width-and-height-text="false"
      ></hallmark-designer-question-measurements>
    </div>

    <div class="designeroption" v-if="reference_on" data-designer-component-id="reference">
      <h3>Enter A Door Reference</h3>
      <div class="stylesoption">
        <div class="form-group">
          <input dusk="door_reference" type="text" v-model="door.attr.reference" class="form-control">
        </div>
      </div>
    </div>
    <input v-else dusk="door_reference" type="hidden" v-model="door.attr.reference" class="form-control"
           value="Retail Door">

    <designer-question-notes v-model:target="door.attr.notes" :placeholder="notes_placeholder"></designer-question-notes>

    <designer-navigation
      v-if="show_navigation"
      :visible_designer_configurator_components="visible_designer_configurator_components"
      transition="designer-navigation"
    ></designer-navigation>

  </div>

</template>

<script type="text/ecmascript-6">
import DoorConfigurator from "../DoorConfigurator.vue";

export default {
  mixins: [
    DoorConfigurator
  ],
  computed: {
    is_firedoorrange() {
      return this.door_type === 'fire';
    },
    is_stable(){
      return this.door_type === 'stable';
    },
    suites() {
      return '67';
    },
    measurements_extra_text() {
      return '';
    },
    notes_placeholder() {
      return "";
    },
  },
  methods: {
      defaults() {
          return {
              166: {
                  "attr": {
                      "fabricator": 32,
                      "door_range": 166,
                      "type": 10,
                      "frame_colour_external": 1084,
                      "colour_range": 22,
                      "door_colour_internal": 1084,
                      "door_drip_colour": 1084,
                      "external_colour": 1084,
                      "frame_material": 99,
                      "hardware_colour": 16986,
                      "hardware_handle": 3669,
                      "hardware_hinge": 1854,
                      "hinge_side": 1,
                      "opening_direction": 1,
                      "secured_by_design": 1,
                      "slab": 2799,
                      "frame_style": {"frame_id": 65, "checkedPanels": []},
                      "laminated_glass": 1,
                      "hardware_lock": 1855,
                      "hardware_cylinder": 1851,
                      "hardware_security_chain": 317,
                      "hardware_letterbox": 318,
                      "hardware_knocker": 315,
                      "hardware_spy_hole": 316,
                      "profile": 144640530,
                      "threshold": 120912,
                      "side_panels": {
                          "left_composite_id": null,
                          "right_composite_id": null,
                          "left_composite_glass_id": null,
                          "right_composite_glass_id": null,
                          "side_glass_text": {"text": "", "position": null}
                      },
                      "numerals": [326, 326, 326, 326],
                      "addons": {
                          "left": {},
                          "right": {},
                          "top": {},
                          "bottom": {},
                      },
                      "cill": 149,
                      "drainage": 1,
                      "notes": "",
                      "cut_to_size": 82,
                      "measurements": {
                          "overall_width": "785",
                          "overall_height": "1925",
                          "left_width": null,
                          "right_width": null,
                          "top_box_drop": null
                      },
                      "trickle_vents": 1721,
                      "panel_category": 52,
                      "panel_core": 3,
                      "panel_depth": 3,
                      "hardware_suite": 67,
                      "frame_colour_internal": 1084,
                      "hinge_spanner": 79,
                      "hardware_hinge_bolts": 754
                  }
              },
              167: {
                  "attr": {
                      "fabricator": 32,
                      "door_range": 167,
                      "type": 10,
                      "frame_colour_external": 1084,
                      "colour_range": 22,
                      "door_colour_internal": 1084,
                      "door_drip_colour": 1084,
                      "external_colour": 1084,
                      "frame_material": 99,
                      "hardware_colour": 16986,
                      "hardware_handle": 3669,
                      "hardware_hinge": 1854,
                      "hinge_side": 1,
                      "opening_direction": 1,
                      "secured_by_design": 1,
                      "slab": 2894,
                      "frame_style": {"frame_id": 65, "checkedPanels": []},
                      "laminated_glass": 1,
                      "hardware_lock": 1855,
                      "hardware_cylinder": 1851,
                      "hardware_security_chain": 317,
                      "hardware_letterbox": 318,
                      "hardware_knocker": 315,
                      "hardware_spy_hole": 316,
                      "profile": 144640530,
                      "threshold": 120912,
                      "side_panels": {
                          "left_composite_id": null,
                          "right_composite_id": null,
                          "left_composite_glass_id": null,
                          "right_composite_glass_id": null,
                          "side_glass_text": {"text": "", "position": null}
                      },
                      "numerals": [326, 326, 326, 326],
                      "addons": {
                          "left": {},
                          "right": {},
                          "top": {},
                          "bottom": {},
                      },
                      "cill": 149,
                      "drainage": 1,
                      "notes": "",
                      "cut_to_size": 82,
                      "measurements": {
                          "overall_width": "785",
                          "overall_height": "1925",
                          "left_width": null,
                          "right_width": null,
                          "top_box_drop": null
                      },
                      "trickle_vents": 1721,
                      "panel_category": 52,
                      "panel_core": 3,
                      "panel_depth": 3,
                      "hardware_suite": 67,
                      "frame_colour_internal": 1084,
                      "hinge_spanner": 79,
                      "hardware_hinge_bolts": 754,
                      "glass_design": 1
                  }
              },
              168: {
                  "attr": {
                      "fabricator": 32,
                      "door_range": 168,
                      "type": 10,
                      "frame_colour_external": 1084,
                      "colour_range": 22,
                      "door_colour_internal": 1084,
                      "door_drip_colour": 1084,
                      "external_colour": 1084,
                      "frame_material": 99,
                      "hardware_colour": 16986,
                      "hardware_handle": 3669,
                      "hardware_hinge": 1854,
                      "hinge_side": 1,
                      "opening_direction": 1,
                      "secured_by_design": 1,
                      "slab": 2842,
                      "frame_style": {"frame_id": 65, "checkedPanels": []},
                      "laminated_glass": 1,
                      "hardware_lock": 1855,
                      "hardware_cylinder": 1851,
                      "hardware_security_chain": 317,
                      "hardware_letterbox": 318,
                      "hardware_knocker": 315,
                      "hardware_spy_hole": 316,
                      "profile": 144640530,
                      "threshold": 120912,
                      "side_panels": {
                          "left_composite_id": null,
                          "right_composite_id": null,
                          "left_composite_glass_id": null,
                          "right_composite_glass_id": null,
                          "side_glass_text": {"text": "", "position": null}
                      },
                      "numerals": [326, 326, 326, 326],
                      "addons": {
                          "left": {},
                          "right": {},
                          "top": {},
                          "bottom": {},
                      },
                      "cill": 149,
                      "drainage": 1,
                      "notes": "",
                      "cut_to_size": 82,
                      "measurements": {
                          "overall_width": "785",
                          "overall_height": "1925",
                          "left_width": null,
                          "right_width": null,
                          "top_box_drop": null
                      },
                      "trickle_vents": 1721,
                      "panel_category": 52,
                      "panel_core": 3,
                      "panel_depth": 3,
                      "hardware_suite": 67,
                      "frame_colour_internal": 1084,
                      "hinge_spanner": 79,
                      "hardware_hinge_bolts": 754
                  }
              },
              169: {
                  "attr": {
                      "fabricator": 32,
                      "door_range": 169,
                      "type": 10,
                      "frame_colour_external": 1084,
                      "colour_range": 22,
                      "door_colour_internal": 1084,
                      "door_drip_colour": 1084,
                      "external_colour": 1084,
                      "frame_material": 99,
                      "hardware_colour": 16986,
                      "hardware_handle": 3669,
                      "hardware_hinge": 1854,
                      "hinge_side": 1,
                      "opening_direction": 1,
                      "secured_by_design": 1,
                      "slab": 2853,
                      "frame_style": {"frame_id": 65, "checkedPanels": []},
                      "laminated_glass": 1,
                      "hardware_lock": 1855,
                      "hardware_cylinder": 1851,
                      "hardware_security_chain": 317,
                      "hardware_letterbox": 318,
                      "hardware_knocker": 315,
                      "hardware_spy_hole": 316,
                      "profile": 144640530,
                      "threshold": 120912,
                      "side_panels": {
                          "left_composite_id": null,
                          "right_composite_id": null,
                          "left_composite_glass_id": null,
                          "right_composite_glass_id": null,
                          "side_glass_text": {"text": "", "position": null}
                      },
                      "numerals": [326, 326, 326, 326],
                      "addons": {
                          "left": {},
                          "right": {},
                          "top": {},
                          "bottom": {},
                      },
                      "cill": 149,
                      "drainage": 1,
                      "notes": "",
                      "cut_to_size": 82,
                      "measurements": {
                          "overall_width": "785",
                          "overall_height": "1925",
                          "left_width": null,
                          "right_width": null,
                          "top_box_drop": null
                      },
                      "trickle_vents": 1721,
                      "panel_category": 52,
                      "panel_core": 3,
                      "panel_depth": 3,
                      "hardware_suite": 67,
                      "frame_colour_internal": 1084,
                      "hinge_spanner": 79,
                      "hardware_hinge_bolts": 754,
                      "glass_design": 1,
                      "panel_trim": 3651
                  }
              },
              170: {
                  "attr": {
                      "fabricator": 32,
                      "door_range": 170,
                      "type": 10,
                      "frame_colour_external": 1084,
                      "colour_range": 22,
                      "door_colour_internal": 1084,
                      "door_drip_colour": 82,
                      "external_colour": 1084,
                      "frame_material": 99,
                      "hardware_colour": 22,
                      "hardware_handle": 2918,
                      "hardware_hinge": 1854,
                      "hinge_side": 1,
                      "opening_direction": 1,
                      "secured_by_design": 1,
                      "slab": 2866,
                      "frame_style": {"frame_id": 65, "checkedPanels": []},
                      "laminated_glass": 1,
                      "hardware_lock": 1855,
                      "hardware_cylinder": 1851,
                      "hardware_security_chain": 317,
                      "hardware_letterbox": 318,
                      "hardware_knocker": 315,
                      "hardware_spy_hole": 316,
                      "profile": 144640530,
                      "threshold": 120912,
                      "side_panels": {
                          "left_composite_id": null,
                          "right_composite_id": null,
                          "left_composite_glass_id": null,
                          "right_composite_glass_id": null,
                          "side_glass_text": {"text": "", "position": null}
                      },
                      "numerals": [326, 326, 326, 326],
                      "addons": {
                          "left": {},
                          "right": {},
                          "top": {},
                          "bottom": {},
                      },
                      "cill": 149,
                      "drainage": 1,
                      "notes": "",
                      "cut_to_size": 82,
                      "measurements": {
                          "overall_width": "795",
                          "overall_height": "1935",
                          "left_width": null,
                          "right_width": null,
                          "top_box_drop": null
                      },
                      "trickle_vents": 1721,
                      "panel_category": 52,
                      "panel_core": 3,
                      "panel_depth": 3,
                      "hardware_suite": 67,
                      "frame_colour_internal": 1084,
                      "hinge_spanner": 79,
                      "hardware_hinge_bolts": 754,
                      "glass_design": 1
                  }
              },
              175: {
                  "attr": {
                      "fabricator": 32,
                      "door_range": 175,
                      "type": 10,
                      "frame_colour_external": 1084,
                      "colour_range": 22,
                      "door_colour_internal": 1084,
                      "door_drip_colour": 82,
                      "external_colour": 1084,
                      "frame_material": 99,
                      "hardware_colour": 22,
                      "hardware_handle": 2918,
                      "hardware_hinge": 1854,
                      "hinge_side": 1,
                      "opening_direction": 1,
                      "secured_by_design": 1,
                      "slab": 2848,
                      "frame_style": {"frame_id": 65, "checkedPanels": []},
                      "laminated_glass": 1,
                      "hardware_lock": 1855,
                      "hardware_cylinder": 1851,
                      "hardware_security_chain": 317,
                      "hardware_letterbox": 318,
                      "hardware_knocker": 315,
                      "hardware_spy_hole": 316,
                      "profile": 144640530,
                      "threshold": 120912,
                      "side_panels": {
                          "left_composite_id": null,
                          "right_composite_id": null,
                          "left_composite_glass_id": null,
                          "right_composite_glass_id": null,
                          "side_glass_text": {"text": "", "position": null}
                      },
                      "numerals": [326, 326, 326, 326],
                      "addons": {
                          "left": {},
                          "right": {},
                          "top": {},
                          "bottom": {},
                      },
                      "cill": 149,
                      "drainage": 1,
                      "notes": "",
                      "cut_to_size": 82,
                      "measurements": {
                          "overall_width": "795",
                          "overall_height": "967",
                          "left_width": null,
                          "right_width": null,
                          "top_box_drop": null
                      },
                      "trickle_vents": 1721,
                      "panel_category": 52,
                      "panel_core": 3,
                      "panel_depth": 3,
                      "hardware_suite": 67,
                      "frame_colour_internal": 1084,
                      "hinge_spanner": 79,
                      "hardware_hinge_bolts": 754
                  }
              }
          };
      },
  },
}
</script>
